var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-new-demande d-flex justify-content-center align-items-center",on:{"click":_vm.goAddNewTicket}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"plus"}}),_vm._v(" Nouveau Ticket ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }